import React from "react";
import { aboutData } from "../../Data";
import './aboutstats.css';


export default function AboutStats({ compact = false }) {
    if (!aboutData?.length) return null;

    return (
        <div className={`about-stats ${compact ? "about-stats-compact" : ""}`} aria-label="Studio statistics">
            <ul className="about-stats-list">
                {aboutData.map((item, i) => {
                    return (
                        <li key={i} className="about-stats-item">
                            <span className="about-stats-index" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
                            <div className="about-stats-copy">
                                <span className="about-stats-value">{item.description}</span>
                                <span className="about-stats-label">{item.section}</span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
